// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tR-rj","delete":"styles_delete__fLnju","update":"styles_update__1su6I","add":"styles_add__3TMcQ"};